import { ErrorBoundary } from 'src/components/ErrorBoundary';
import { StencilProvider } from '@amzn/stencil-react-components/context';
import React, { PropsWithChildren } from 'react';
import { timehubAssistantTheme } from '../Widgets/theme';

interface IFederatedComponentWrapper {}

/**
 * Wrapper that encapsulates  federated components within StencilProvider along with Error Boundary
 * */
export const FederatedComponentWrapper: React.FC<PropsWithChildren<IFederatedComponentWrapper>> = ({
  children,
}): JSX.Element => {
  return (
    <ErrorBoundary fallbackUI={<>An error occurred, please try again later</>}>
      <StencilProvider theme={timehubAssistantTheme}>
        <React.Fragment>{children}</React.Fragment>
      </StencilProvider>
    </ErrorBoundary>
  );
};
